import React from 'react';
import MkFounderNote from '../MkFounderNote';

// H6 — the founder's note (full letter with the Bring Me Back CTA row).
const HomeFounder = ({ platform }) => (
  <section className="mk-founder section" id="founder-note" aria-labelledby="mk-founder-title">
    <div className="container-sm">
      <div className="section-inner">
        <MkFounderNote variant="full" platform={platform} placement="home" />
      </div>
    </div>
  </section>
);

export default HomeFounder;
